// Copyright (c) Ensho Health, 2022 to present

import { gql } from 'graphql-request';
import { workflowClient } from './client-gql.js';

export async function fetchCdlServices() {
  try {
    const query = gql`
      query {
        cdlServices {
          all {
            cdlServiceCode
            cdlServiceLabel
            isSinglePatient
            isFullRoster
            isPanel
            isSponsored
          }
        }
      }
    `;

    const response = await workflowClient.request(query);
    let cdlServices = response.cdlServices.all;
    return cdlServices;
  } catch (error) {
    throw error;
  }
}
